export default __webpack_public_path__ + "static/media/tanya_smith.b3f85c92.png";